import {generateFormValidations} from "../../../helpers/antdFormValidations";
import {DepartmentDataServiceFormValues} from "./DepartmentDataServiceForm.types";
import {DEPARTMENT_DATA_SERVICES} from "../../../constants/translates";

const departmentDataServiceFormValidations = generateFormValidations<DepartmentDataServiceFormValues>({
  service_id: [
    { required: true, message: DEPARTMENT_DATA_SERVICES.serviceIdRequired }
  ],
  amount: [
    { required: true, message: DEPARTMENT_DATA_SERVICES.amountRequired },
    {
      pattern: /^0*[0-9]{1,12}(?:\.[0-9]{1,2})?$/,
      message: DEPARTMENT_DATA_SERVICES.amountFormat,
    },
  ],
});

export default departmentDataServiceFormValidations;